import * as classNames from 'classnames';

export const cx = classNames;
